// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"21f31201","815":"e458a74f"}[chunkId] + ".chunk.js";
};